import DeclinedPage from "./DeclinedPage";

export default DeclinedPage